import React from 'react';

import { getDistanceFormatterSelector } from '../../../store/selectors/getDistanceFormatterSelector';
import { getTriangleData, segmentLength } from '../../../three/dimension/getTriangleData';
import { useAppSelector } from '../../hooks';
import { TooltipText } from './common';
import { TooltipBase } from './TooltipBase';

export function DimensionModeTooltip() {
  const distanceFormatter = useAppSelector(getDistanceFormatterSelector);
  const selectedSnaps = useAppSelector((state) => state.selections.selectedSnaps);

  const { snap1, snap2 } = selectedSnaps;
  if (snap1 == null || snap2 == null) return null;

  const { hypotenuse, horizontalLeg, verticalLeg } = getTriangleData({ start: snap1, end: snap2 });

  return (
    <TooltipBase insistent>
      <TooltipText>Distance: {distanceFormatter(segmentLength(hypotenuse))}</TooltipText>
      {horizontalLeg && <TooltipText>Width: {distanceFormatter(segmentLength(horizontalLeg))}</TooltipText>}
      {verticalLeg && <TooltipText>Height: {distanceFormatter(segmentLength(verticalLeg))}</TooltipText>}
    </TooltipBase>
  );
}
